<template>
    <v-container>
        <v-form ref="form">
            <v-row class="justify-between">
                <v-text-field
                    v-model="fname"
                    :rules="nameRules"
                    label="Förnamn"
                    style="margin-left:10px"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="lname"
                    :rules="nameRules"
                    label="Efternamn"
                    required
                ></v-text-field>
            </v-row>
            <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Din mail"
                required
            ></v-text-field>

            <v-text-field
                v-model="password"
                type="password"
                :rules="passRules"
                label="Lösenord"
                required
            ></v-text-field>

            <v-text-field
                v-model="cnfpass"
                type="password"
                label="Bekräfta lösenord"
                :rules="[v => v === password || 'Lösenord matchar inte']"
                required
            ></v-text-field>

            <v-btn
                style="background-color:#ffa500"
                class="mr-4"
                v-on:click="submit"
                :loading="loading"
            >
                Överlämna
                <v-icon style="font-size:13px;margin-left:6px;">fas fa-edit</v-icon>
            </v-btn>

            <v-btn color="error" class="mr-4" v-on:click="reset">
                Återställa
                <v-icon style="font-size:13px;margin-left:6px;">fas fa-times</v-icon>
            </v-btn>
        </v-form>
    </v-container>
</template>

<script>
import store from "../../../store";
export default {
    store: store,
    props: ["createmeeting"],
    data: () => ({
        isActive: false,
        loading: false,
        valid: false,
        fname: "",
        lname: "",
        nameRules: [v => !!v || "Namn krävs"],
        email: "",
        cnfpass: "",
        emailRules: [
            v => !!v || "Din mail krävs",
            v => /.+@.+\..+/.test(v) || "Ange giltigt e-postmeddelande"
        ],
        select: null,
        password: "",
        passRules: [
            v => !!v || "lösenord krävs",
            v => v.length >= 8 || "Lösenordet måste bestå av minst 8 tecken"
        ]
    }),
    created: {
        function() {
            if (this.$store.state.isLoggedIn && !this.createmeeting)
                this.$router.replace("/admin/dashboard");
        }
    },
    methods: {
        validate() {
            this.$refs.form.validate();
        },
        reset() {
            this.$refs.form.reset();
            this.loading = false;
        },
        async submit() {
            this.loading = true;
            await this.validate();
            let bodyFormData = new FormData();
            bodyFormData.set("first_name", this.fname);
            bodyFormData.set("last_name", this.lname);
            bodyFormData.set("email", this.email);
            bodyFormData.set("password", this.password);
            bodyFormData.set("password", this.password);
            bodyFormData.set("c_password", this.cnfpass);
            bodyFormData.set("role", "admin");
            const config = {
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };

            if (this.$refs.form.validate()) {
                await this.$store
                    .dispatch("register", config)
                    .then(() => (this.loading = false))
                    .catch(() => {
                        this.isLoading = false;
                    });
                if (this.createmeeting) this.loading = false;
                else this.$router.replace("/admin/dashboard");
            } else {
                this.$store.state.showAlert = true;
                this.$store.state.alertMsg = "Fyll i lämplig information";
                this.$store.state.alertType = "error";
                this.loading = false
            }
        }
    }
};
</script>
